export default __webpack_public_path__ + "static/media/application modernization.d860be55.svg";